var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCny = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56719 7.57202L7.60313 10.7595H10.9547L8.24531 12.733L9.28125 15.9205L6.56719 13.9517L3.85313 15.9205L4.89375 12.733L2.17969 10.7595H5.53125L6.56719 7.57202Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.227 18.854L13.4348 17.8791L12.2629 18.3337L12.9426 17.2791L12.1504 16.2994L13.3645 16.6228L14.0488 15.5681L14.1145 16.8244L15.3332 17.1478L14.1566 17.5978L14.227 18.854Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.802 15.9947L16.177 14.7947L15.1504 14.0681L16.4066 14.0494L16.777 12.8494L17.1848 14.04L18.441 14.0259L17.4332 14.7759L17.8363 15.9666L16.8098 15.24L15.802 15.9947Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9266 9.07358L17.3734 10.2033L18.2734 11.0798L17.0312 10.9017L16.4781 12.0267L16.2625 10.7892L15.0156 10.6111L16.1313 10.0251L15.9156 8.78296L16.8156 9.65952L17.9266 9.07358Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2582 5.65405L14.1645 6.90562L15.3316 7.37906L14.1082 7.67906L14.0191 8.93531L13.3582 7.86656L12.1348 8.16656L12.9457 7.20562L12.2801 6.14155L13.4473 6.61499L14.2582 5.65405Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCny);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CNY.a94f99e2a103043b3f69ff1b2e6ea19c.svg";